<template>
  <div class="addSpecialFundsSelfInspection">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">{{ Form.organization }}</div>
        <blank height="7"> </blank>
      </div>
      <div v-else>
        <div class="newsDetial-title">
          {{ Form.organization }}2021年度第一季度表单审批流程
        </div>
        <blank height="7"> </blank>
        <a-button
          v-if="Form.state == 2"
          class="detial-top-btn"
          type="primary"
          icon="printer"
          @click="printDDD()"
        >
          打印
        </a-button>
      </div>
      <a-tabs v-model="tabnum" @tabClick="tabClick">
        <a-tab-pane key="1" tab="表单详情" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane key="2" tab="表单流程" v-if="tabnum == 2" />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">新建表单</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照要求填写相关信息，并提交进行流程审批
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <div class="detial-cont-title">申请表单</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label">部门/单位 <span class="required">*</span></span>
            <a-tooltip placement="topLeft" :title="Form.organization">
              <div>
                <a-input
                  v-if="id"
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.organization"
                  disabled
                />
                <a-select
                  v-else
                  class="w300"
                  placeholder="请选择"
                  v-model="Form.organizationId"
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in organizationUserList"
                    :value="item.organizationId"
                    :key="item.organizationId"
                  >
                    {{ item.organizationname }}</a-select-option
                  >
                </a-select>
              </div>
            </a-tooltip>
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label">申请人 <span class="required">*</span></span>
            <a-input
              class="w300"
              placeholder="请输入"
              v-model="Form.principal"
              :disabled="true"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >自查时间范围 <span class="required">*</span></span
            >
            <a-select class="w300" v-model="year" :disabled="disabled">
              <a-select-option
                v-for="item in years"
                :key="item.value"
                :value="item.value"
                >{{ item.label }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">资料等级 <span class="required">*</span></span>
            <a-select
              placeholder="请选择"
              class="w300"
              v-model="Form.secret"
              disabled
            >
              <a-select-option :value="100">重要</a-select-option>
              <a-select-option :value="10">普通</a-select-option>
            </a-select>
          </a-descriptions-item>

          <a-descriptions-item label="备注">
            <a-input
              class="w300"
              v-model="Form.remark"
              :disabled="disabled"
              @change="eightyfive('remark')"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <template v-if="lastYearData.length > 0 && getLookIndex == 5">
        <blank height="20"> </blank>
        <div class="detial-cont-title">统计结果</div>
        <blank height="1"> </blank>
        <div class="detial-cont-view">
          <!-- <div class="scrollBox"> -->
          <template v-for="(ExcelItem, index) in lastYearData">
            <div class="excel_cont1" :key="index">
              <div
                class="excel_item1"
                v-for="(item, index1) in ExcelItem"
                :key="index1"
              >
                {{ item }}
              </div>
            </div>
          </template>
          <!-- </div> -->
        </div>
      </template>
      <template v-for="(ExcelList, index0) in specialFundsExcelList">
        <div
          :key="index0"
          v-if="getLookIndex == 5 || getLookIndex == index0 + 1"
        >
          <blank height="20"> </blank>
          <div class="detial-cont-title">
            {{ Form.reportedYear }}年第{{ index0 + 1 }}季度

            <div class="state0 ml10" v-if="getState(ExcelList) == 0">
              待提交
            </div>
            <div class="state1 ml10" v-if="getState(ExcelList) == 1">
              审批中
            </div>
            <div class="state2 ml10" v-if="getState(ExcelList) == 2">
              已归档
            </div>
            <div class="state3 ml10" v-if="getState(ExcelList) == 3">退回</div>
            <div class="state4 ml10" v-if="getState(ExcelList) == 4">取消</div>
            <a-button
              v-show="
                ExcelList[0] === undefined
                  ? ExcelList.length > 0
                  : ExcelList[0].length > 0
              "
              type="link"
              class="title-btn btn-link"
              @click="viewApproval(ExcelList, index0)"
            >
              查看审批流
            </a-button>
          </div>
          <blank height="1"> </blank>
          <div class="detial-cont-view">
            <div class="scrollBox">
              <template v-for="(ExcelItem, index) in ExcelList">
                <div
                  class="excel_cont"
                  :key="index"
                  v-if="index < ExcelList.length - 1"
                >
                  <div
                    class="excel_item"
                    v-for="(item, index1) in ExcelItem"
                    :key="index1"
                  >
                    <a-tooltip placement="topLeft" :title="item">
                      {{ item }}
                    </a-tooltip>
                  </div>
                </div>
              </template>
            </div>
            <div
              class="accessory-btn"
              v-if="
                ExcelList.length < 2 &&
                (getStateIndex == index0 + 1 || getStateIndex == 5) &&
                iSreportedQuarter == 0
              "
            >
              <a-button icon="plus" @click="importOk(index0 + 1)">
                导入数据
              </a-button>
            </div>
            <div v-else-if="specialFundsFiles[index0]" class="mt20">
              <a-icon class="blue" type="link" />
              <span class="mr20">
                {{ specialFundsFiles[index0].filename }} .xlsx</span
              >
              <a-button
                type="link"
                class="btn-link"
                @click="goDetial(specialFundsFiles[index0])"
              >
                查看
              </a-button>
              <a-divider type="vertical" />
              <a-button
                type="link"
                class="btn-link"
                @click="
                  download(
                    specialFundsFiles[index0].mongoFileId,
                    specialFundsFiles[index0].filename,
                    specialFundsFiles[index0].fileformat
                  )
                "
              >
                下载
              </a-button>
              <template
                v-if="
                  getState(ExcelList) == 3 &&
                  Form.reportedQuarter == index0 + 1 &&
                  getStateIndex != 0 &&
                  proQueryParams.showApproveBtn == 1
                "
              >
                <a-divider type="vertical" />
                <a-button
                  type="link"
                  class="btn-link"
                  @click="showDeleteConfirm()"
                >
                  删除
                </a-button>
              </template>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <!-- 审批流 表单流程 -->
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template
          v-if="getStateIndex == 5 && proQueryParams.showApproveBtn != 1"
        >
          <a-button
            :loading="loading"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn(2)"
          >
            提交
          </a-button>
        </template>
        <!-- 表单正在审批状态  显示审批按钮 -->
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <template v-if="getStateIndex != 0">
            <a-button
              :loading="loading"
              type="primary"
              :style="{ marginRight: '20px' }"
              @click="submitFn(2)"
            >
              提交
            </a-button>
          </template>
          <!-- <a-button
            v-if="Form.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            取消
          </a-button> -->
          <!-- <a-button
            v-if="Form.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('1')"
            :style="{ marginRight: '20px' }"
          >
            提交
          </a-button> -->
          <a-button
            v-if="Form.state === 3 ? false : true"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button>
        </div>
      </bottomSuspension>
    </template>

    <a-modal
      :visible="visible > 0"
      title="批量操作"
      :footer="null"
      @cancel="() => (visible = 0)"
    >
      <prompts>
        操作步骤
        <span slot="two">
          1. 下载Excel导入模版。 2. 填写信息到Excel模版。 3.
          将填写好信息的Excel回传到系统<blank height="8"> </blank
        ></span>
      </prompts>
      <div class="xlsx">
        <a-icon type="link" />
        专项资金自查批量上传模版.xlsx
      </div>
      <div class="xlsx-btn">
        <a-button
          icon="vertical-align-bottom"
          type="primary"
          @click="downTemplate"
        >
          下载模板</a-button
        >

        <a-upload
          name="file"
          :multiple="false"
          action="#"
          :fileList="bfileList"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          @change="uploading"
        >
          <a-button icon="vertical-align-top" type="primary">
            上传Excel</a-button
          >
        </a-upload>
      </div>
      <blank height="100"> </blank>
    </a-modal>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <print
      v-model="isPrint"
      v-if="Form.state == 2"
      :id="id"
      mobilePath="/pages/workbench/specialFunds/details?id="
      skipPageReqFlag="/SpecialFundsSelfInspectionDetial"
    >
      <div class="print-title">
        {{ Form.reportedYear }}年专项资金收支情况自查表
      </div>
      <div class="printd-cont">
        <div class="printd-item">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="部门/单位" :span="1.5">
              {{ Form.organization }}
            </a-descriptions-item>
            <a-descriptions-item label="申请人" :span="1.5">
              {{ Form.principal }}
            </a-descriptions-item>
            <a-descriptions-item label="自查时间范围" :span="1.5">
              {{ Form.reportedYear }}年
            </a-descriptions-item>
            <a-descriptions-item label="资料等级" :span="1.5">
              {{ Form.secret == 100 ? '重要' : '普通' }}
            </a-descriptions-item>
            <a-descriptions-item label="备注" :span="3">
              {{ Form.remark }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  updateSpecialFunds,
  SpecialFundsDetial,
  addSpecialFunds,
  importTemplate,
  importExcel,
  delSpecialFunds
} from './api/api'
import { getSuffix } from '@/assets/js/auth'
import { kkFileUrl, fileUrlHOST } from '@/http/config'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { activitiSubmission } from '@/utils/utils'
import { saveFile, getFile } from '@/http/url'
export default {
  components: {
    approvalSubmission,
    approvalChart
  },
  data() {
    return {
      visible: 0,
      iSreportedQuarter: 0, // 当前修改的季度
      loading: false,
      tabnum: '1', // 1表单页面， 2审批流页面
      Form: {},
      yearsModel: null,
      year: '',
      years: [],
      bfileList: [],
      id: '',
      dateFormat: 'YYYY-MM-DD',
      lastYearData: [], // 统计结果
      specialFundsExcelList: [[], [], [], []], // Excel数据列表
      specialFundsFiles: [], // Excel文件列表
      // 审批流部分
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      approvalData: [],
      // 审批流部分
      // 打印部分
      isPrint: false, // 打印弹窗
      columns: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'left'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'left'
        }
      ],
      formDTOList: []
    }
  },

  computed: {
    ...mapState({
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      queryUserList: (state) => state.app.queryUserList // 用户列表
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    },
    //获取当前可显示的季度  5为添加全部显示 1~4为准确的只可显示的季度  其余不显示
    getLookIndex: function () {
      if (!this.id) {
        // 第一次添加  可随意添加任意季度 全部显示
        return 5
      } else {
        let proQueryParams = this.$route.query
        if (proQueryParams.taskId) {
          // 从工作台审批流进入
          return this.Form.reportedQuarter // 只显示当前季度数据
        } else {
          // 从工工作台我的申请或列表进入   全部显示
          return 5
        }
      }
    },
    //获取当前可编辑/导入的季度 5为添加全部可编辑 0为不可编辑  1~4为准确的可编辑的季度
    getStateIndex: function () {
      if (!this.id) {
        // 第一次添加  可随意添加任意季度
        return 5
      } else {
        // 查看或审批流进入
        let createUserId = this.$store.state.app.userInfo.id
        if (createUserId == this.Form.createUserId) {
          // 是当前数据提交人
          if (this.Form.state == 3) {
            // 当前季度为退回状态 只可改变当前季度
            return this.Form.reportedQuarter
          } else if (this.Form.state == 2) {
            //当前季度为归档状态
            let reportedQuarter = 5 // 默认都能编辑
            this.specialFundsExcelList.forEach((item, index) => {
              if (item.length > 1) {
                // 有数据
                if (item[item.length - 1][0].state == 3) {
                  // 退回状态 返回当前季度
                  reportedQuarter = item[item.length - 1][0].reportedQuarter
                  return
                } else if (item[item.length - 1][0].state != 2) {
                  // 不是归档状态 都不能修改
                  reportedQuarter = 0
                }
              }
            })
            return reportedQuarter
          } else {
            // 当前季度为审批中或取消状态  不可更改
            return 0
          }
        } else {
          // 不是当前数据提交人  不可更改
          return 0
        }
      }
    }
  },
  created() {
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.getorganizationUserList()
    this.init()
    if (this.id) {
      this.load()
    } else {
      this.Form.principal = this.$store.state.app.userInfo.fullName
      this.Form.secret = 100
      this.$set(
        this.Form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  methods: {
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '专项资金自查-' +
        this.Form.principal +
        this.$printFormatDate(new Date())
    },
    // 查看审批流
    viewApproval(ExcelList, index) {
      switch (index) {
        case 0:
          // 第一季度
          if (this.approvalData.quarter1[0].length > 0) {
            let quarter1 =
              this.approvalData.quarter1[
                this.approvalData.quarter1.length - 1
              ][0].processInstanceId
            let processInstanceId = {
              processInstanceId: quarter1,
              detailsData: this.Form
            }
            Object.assign(this.proQueryParams, processInstanceId)
            // 显示tab切换 表单流程
            this.tabnum = '2'
            this.tabClick('2')
          }
          break
        case 1:
          // 第一季度
          if (this.approvalData.quarter2[0].length > 0) {
            let quarter2 =
              this.approvalData.quarter2[
                this.approvalData.quarter2.length - 1
              ][0].processInstanceId
            let processInstanceId = {
              processInstanceId: quarter2,
              detailsData: this.Form
            }
            Object.assign(this.proQueryParams, processInstanceId)
            // 显示tab切换 表单流程
            this.tabnum = '2'
            this.tabClick('2')
          }
          break
        case 2:
          // 第一季度
          if (this.approvalData.quarter3[0].length > 0) {
            let quarter3 =
              this.approvalData.quarter3[
                this.approvalData.quarter3.length - 1
              ][0].processInstanceId
            let processInstanceId = {
              processInstanceId: quarter3,
              detailsData: this.Form
            }
            Object.assign(this.proQueryParams, processInstanceId)
            // 显示tab切换 表单流程
            this.tabnum = '2'
            this.tabClick('2')
          }
          break
        case 3:
          // 第一季度
          if (this.approvalData.quarter4[0].length > 0) {
            let quarter4 =
              this.approvalData.quarter4[
                this.approvalData.quarter4.length - 1
              ][0].processInstanceId
            let processInstanceId = {
              processInstanceId: quarter4,
              detailsData: this.Form
            }
            Object.assign(this.proQueryParams, processInstanceId)
            // 显示tab切换 表单流程
            this.tabnum = '2'
            this.tabClick('2')
          }
          break
        default:
          break
      }
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {}
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否删除?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {}
          })
          break

        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.load()
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    ...mapActions(['getorganizationUserList']),
    importOk(i) {
      this.visible = i
    },
    // 输入框限制85
    eightyfive(v) {
      if (this.Form[v].length > 200) {
        this.Form[v] = this.Form[v].substring(0, 200)
        this.$message.destroy()
        this.$message.warning('只能输入200个字')
      }
    },
    showDeleteConfirm() {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          delSpecialFunds({ id: this.id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    downTemplate() {
      //下载模板
      importTemplate().then((response) => {
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = '专项资金自查批量上传模版.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    beforeUpload(file, fileList) {
      return false
    },
    uploading(file) {
      this.$message.loading('导入中···', 0)
      let formDataChildren = new FormData()
      formDataChildren.append('file', file.file)
      importExcel(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.specialFundsExcelList[this.visible - 1] = res.data.data.result
          if (this.Form.state == 3) {
            // 如果是退回修改
            this.specialFundsExcelList[this.visible - 1][
              res.data.data.result.length - 1
            ][0].id = parseInt(this.id)
            this.specialFundsExcelList[this.visible - 1][
              res.data.data.result.length - 1
            ][0].state = 3
          }
          let fileData = {}
          let SuffixArray = getSuffix(file.file.name)
          fileData.filename = SuffixArray[1]
          fileData.fileformat = SuffixArray[0]
          fileData.mongoFileId = res.data.data.mongoId
          fileData.kkFileUrl = kkFileUrl
          fileData.fileUrl =
            fileUrlHOST +
            'mongo/kkFile?fileId=' +
            fileData.mongoFileId +
            '&fullfilename=' +
            SuffixArray[2]
          fileData.reportedQuarter = this.visible
          this.iSreportedQuarter = this.visible //当前所修改的季度
          this.specialFundsFiles[this.visible - 1] = fileData
          this.$message.destroy()
          this.visible = 0
          this.$message.success('导入成功')
        }
      })
    },
    goDetial(item) {
      // 查看
      if (item.fileformat == 'bpmn') {
        this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
      } else {
        // window.open(item.kkFileUrl + encodeURIComponent(item.fileUrl))
        let Base64 = require('js-base64').Base64
        window.open(
          item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
        )
      }
    },
    download(mongoFileId, filename, fileformat) {
      // 下载附件
      this.$message.loading('下载中···', 0)
      getFile(mongoFileId).then((res) => {
        this.$message.destroy()
        this.$message.success('下载成功')
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = filename + '.' + fileformat
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    goback() {
      this.$router.push('/SpecialFundsSelfInspection')
    },
    init() {
      // 获取年月列表
      var myDate = new Date()
      this.year = this.yearsModel = myDate.getFullYear() //获取当前年
      this.initSelectYear(this.yearsModel)
      if (!this.id) {
        this.year = this.yearsModel
      }
    },
    initSelectYear(year) {
      this.years = []
      for (let i = 0; i < 20; i++) {
        this.years.push({ value: year - i, label: year - i + '年度' })
      }
    },
    getState(ExcelList) {
      if (ExcelList.length > 1) {
        // 有数据
        return ExcelList[ExcelList.length - 1][0].state
      } else {
        return '-1'
      }
    },
    load() {
      SpecialFundsDetial({ id: this.id }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.year = this.Form.reportedYear
          this.specialFundsFiles = res.data.data.specialFundsFiles
          this.lastYearData = res.data.data.specialFundsExcelList.lastYearData
          this.specialFundsExcelList[0] =
            res.data.data.specialFundsExcelList.quarter1
          this.specialFundsExcelList[1] =
            res.data.data.specialFundsExcelList.quarter2
          this.specialFundsExcelList[2] =
            res.data.data.specialFundsExcelList.quarter3
          this.specialFundsExcelList[3] =
            res.data.data.specialFundsExcelList.quarter4
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
          // 获取每个季度 processInstanceId
          let filterProcssId = res.data.data.specialFundsExcelList
          delete filterProcssId.lastYearData
          this.approvalData = filterProcssId
        }
      })
    },
    submitFn(type) {
      // console.log(this.Form)
      // return
      if (this.Form.state == 3) {
        // 保存修改
        if (this.iSreportedQuarter > 0) {
          // 确定是否已修改
          this.Form.draft = 2
          this.saveFormFn('添加')
        } else {
          this.cancelPro('1')
          // this.$message.warning('当前未修改数据！')
        }
        //说明已修改
      } else {
        //提交
        if (this.iSreportedQuarter > 0) {
          // 确定是否已导入数据
          this.$confirm({
            title: '确定提交吗?',
            okType: 'danger',
            onOk: () => {
              this.Form.draft = 2
              this.saveFormFn('添加')
            }
          })
        } else {
          this.$message.warning('当前未导入数据！')
        }
      }
    },
    saveFormFn(type) {
      if (!this.Form.organizationId) {
        this.$message.error('请添加部门')
        return false
      }
      // 导入数据赋值
      let FundsExcelList =
        this.specialFundsExcelList[this.iSreportedQuarter - 1] //当前所导入季度数据
      let ExcelItem = FundsExcelList[FundsExcelList.length - 1] // 取最后一项
      //  每一项赋值季度
      let NewsExcelItem = ExcelItem.map((items, indexs) => {
        items.reportedQuarter = this.iSreportedQuarter
        return items
      })
      this.Form.specialFundsImportExcel = NewsExcelItem
      let specialFundsExcelRes = {}
      specialFundsExcelRes.reportedQuarter = this.iSreportedQuarter
      specialFundsExcelRes.reportedYear = this.year
      this.Form.addSpecialFundsExcelReq = specialFundsExcelRes
      // 导入数据赋值

      this.Form.reportedYear = this.year
      this.Form.specialFundsFiles =
        this.specialFundsFiles[this.iSreportedQuarter - 1]
      this.Form.appId = this.$route.meta.appId
      this.Form.skipPageReqFlag = '/SpecialFundsSelfInspectionDetial'
      this.loading = true
      if (this.id && this.Form.state == 3) {
        // 退回状态 走修改
        this.Form.id = this.id
        updateSpecialFunds(this.Form).then((res) => {
          if (res.data.code == 0) {
            if (this.Form.state > 0) {
              this.load()
              // this.$message.success('修改成功')
              this.cancelPro('1')
            } else {
              if (this.Form.draft == 2) {
                this.$message.success('提交成功')
              } else {
                this.$message.success('保存成功')
              }
              this.goback()
            }
            this.loading = false
          } else {
            this.loading = false
          }
        })
      } else {
        //获取部门名称
        let organizationName = ''
        this.organizationUserList.forEach((item, index) => {
          if (item.organizationId == this.Form.organizationId) {
            organizationName = item.organizationname
          }
        })
        this.Form.organization = organizationName
        addSpecialFunds(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(type + '成功')
            this.goback()
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.addSpecialFundsSelfInspection {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      position: relative;
      .title-btn {
        position: absolute;
        right: 30px;
      }
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .scrollBox {
        overflow-x: scroll;
        /* 内容会被裁剪，会以滚动条显示 */
        overflow-y: hidden; /* 超出内容不可见 */
        white-space: nowrap; /* 不换行 */
      }
      .excel_cont1 {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 10px;
      }
      .excel_item1 {
        text-align: center;
        width: 250px;
        // margin-right: 10px;
        display: inline-block; /* 不换行 */
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .excel_cont {
        // display: flex;
        // align-items: center;
        // justify-content: flex-start;
        margin-bottom: 10px;
      }
      .excel_item {
        text-align: center;
        width: 150px;
        margin-right: 10px;
        display: inline-block; /* 不换行 */
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
    }
  }
}
.xlsx {
  // width: 204px;
  height: 22px;
  margin: 32px 25px;
  color: rgba(166, 166, 166, 1);
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}
.xlsx-btn {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
</style>

<style scoped src="@/assets/css/printModal.css"></style>



// WEBPACK FOOTER //
// src/views/SpecialFundsSelfInspection/detial.vue